import React, {useMemo}								from 'react';

import Badge										from '../Badge';

import {useAppSelector}								from '../../../app/hooks';
import {FilterChecked}								from '../Modal/interface';
import {LanguageFilters}							from '../../language/type';

import LANGUAGE										from '../../language';


interface Props {
	filters: FilterChecked[],
	setFilters: (newFilters: FilterChecked[]) => void
}

function FiltersBadge(props: Props) {
	const lang = useAppSelector(state => state.settings.lang);

	const TEXTE = LANGUAGE(lang);

	const badges = useMemo(() => {
		const render: JSX.Element[] = [];

		props.filters.forEach((filter, i) => {
			filter.values.forEach((filterValue, i2) => {
				render.push(
					<Badge
						color={'tertiary'}
						onClose={() => onClose(i, i2)}
					>{TEXTE.filters[filterValue as keyof LanguageFilters] || filterValue}</Badge>
				);
			});
		});

		return render;
	}, [props.filters]);

	const onClose = (i: number, i2: number) => {
		const copy = [...props.filters];

		copy[i].values.splice(i2, 1);

		if (copy[i].values.length === 0)
			copy.splice(i, 1);
		props.setFilters(copy);
	};

	return <div className={'usersModalFilter'}>{badges}</div>;
}

export default FiltersBadge;